import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/user/account/union.png';
import _imports_1 from '@/assets/img/user/account/vip_ic.png';
import _imports_2 from '@/assets/img/user/account/illustration_bg.png';
const _withScopeId = n => (_pushScopeId("data-v-52adae90"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "pageView" };
const _hoisted_2 = { class: "selectTab flex" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
    key: 0,
    class: "interestList"
};
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "unionImg",
    src: _imports_0,
    alt: ""
}, null, -1));
const _hoisted_6 = { class: "vipTitle" };
const _hoisted_7 = { class: "flex" };
const _hoisted_8 = { class: "flex-align-center vipLeft" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "vipImg" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_1,
        alt: ""
    })
], -1));
const _hoisted_10 = { class: "vipDetail" };
const _hoisted_11 = { class: "endTime" };
const _hoisted_12 = { class: "vipDiscount" };
const _hoisted_13 = { class: "vipNums" };
const _hoisted_14 = /*#__PURE__*/ _createTextVNode("折优惠 ");
const _hoisted_15 = {
    key: 1,
    class: "interestList"
};
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "unionImg",
    src: _imports_2,
    alt: ""
}, null, -1));
const _hoisted_17 = { class: "vipTitle gary" };
const _hoisted_18 = { class: "flex" };
const _hoisted_19 = { class: "flex-align-center vipLeft" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "vipImg failureImg" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_1,
        alt: ""
    })
], -1));
const _hoisted_21 = { class: "vipDetail" };
const _hoisted_22 = { class: "endTime" };
const _hoisted_23 = { class: "vipDiscount gary" };
const _hoisted_24 = { class: "vipNums gary" };
const _hoisted_25 = /*#__PURE__*/ _createTextVNode("折优惠 ");
const _hoisted_26 = { class: "noMore" };
import { ref, onMounted, getCurrentInstance } from 'vue';
import { getUserId } from '@/widget/index';
import { getUserRights } from '@/api/user';
import Empty from '@/components/common/Empty.vue';
import BScroll from '@/components/common/BetterScroll.vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const typeList = ref([
            {
                label: '生效中',
                id: 1
            },
            {
                label: '已失效',
                id: 2
            }
        ]);
        const tabType = ref(1);
        let userId = getUserId();
        const listBs = ref(); // 上拉加载
        let loaded = ref(false); // 是否加载完成
        const noMore = ref(false); // 是否还有更多
        var pageNo = 1; //当前页数
        var pageCount = 1; //共有多少页
        const interestData = ref([]);
        const { proxy: { $showLoading, $hideLoading } } = getCurrentInstance();
        const selectType = (type) => {
            interestData.value = [];
            pageNo = 1;
            tabType.value = type;
            getInterestData();
        };
        const getInterestData = () => {
            $showLoading();
            loaded.value = false;
            getUserRights({
                type: tabType.value,
                userId
            }, {
                pageNo,
                pageSize: 10
            }).then((res) => {
                loaded.value = true;
                $hideLoading();
                if (res.code === 200) {
                    pageCount = res.data.pageCount;
                    if (pageCount === 1) {
                        interestData.value = res.data.list;
                    }
                    else {
                        interestData.value = interestData.value.concat(res.data.list);
                    }
                    if (pageNo >= pageCount) {
                        noMore.value = true;
                    }
                    else {
                        noMore.value = false;
                        pageNo++;
                    }
                }
            });
        };
        onMounted(() => {
            getInterestData();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(BScroll, {
                    ref: (_value, _refs) => {
                        _refs['listBs'] = _value;
                        listBs.value = _value;
                    },
                    options: {
                        scrollY: true,
                        scrollX: false,
                        click: true,
                        mouseWheel: true,
                        scrollbar: {
                            fade: false,
                            interactive: true
                        },
                        pullUpLoad: true
                    },
                    loaded: _unref(loaded),
                    noMore: noMore.value,
                    onUpLoad: getInterestData,
                    domStyle: {
                        position: 'relative',
                        height: '100vh'
                    }
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("ul", _hoisted_2, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.value, (tab) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: tab.id,
                                    class: _normalizeClass({ active: tabType.value === tab.id }),
                                    onClick: ($event) => (selectType(tab.id))
                                }, _toDisplayString(tab.label), 11, _hoisted_3));
                            }), 128))
                        ]),
                        (tabType.value === 1 && interestData.value.length > 0)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(interestData.value, (item, index) => {
                                    return (_openBlock(), _createElementBlock("li", { key: index }, [
                                        _hoisted_5,
                                        _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1),
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("div", _hoisted_8, [
                                                _hoisted_9,
                                                _createElementVNode("div", _hoisted_10, [
                                                    _createElementVNode("p", null, _toDisplayString(item.desc), 1),
                                                    _createElementVNode("p", _hoisted_11, "到期时间：" + _toDisplayString(item.endTime), 1)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_12, [
                                                _createElementVNode("span", _hoisted_13, _toDisplayString(item.discountText1), 1),
                                                _hoisted_14
                                            ])
                                        ])
                                    ]));
                                }), 128))
                            ]))
                            : (tabType.value === 2 && interestData.value.length > 0)
                                ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(interestData.value, (item, index) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            class: "failureBox",
                                            key: index
                                        }, [
                                            _hoisted_16,
                                            _createElementVNode("div", _hoisted_17, _toDisplayString(item.title), 1),
                                            _createElementVNode("div", _hoisted_18, [
                                                _createElementVNode("div", _hoisted_19, [
                                                    _hoisted_20,
                                                    _createElementVNode("div", _hoisted_21, [
                                                        _createElementVNode("p", null, _toDisplayString(item.desc), 1),
                                                        _createElementVNode("p", _hoisted_22, "到期时间：" + _toDisplayString(item.endTime), 1)
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_23, [
                                                    _createElementVNode("span", _hoisted_24, _toDisplayString(item.discountText1), 1),
                                                    _hoisted_25
                                                ])
                                            ])
                                        ]));
                                    }), 128))
                                ]))
                                : _createCommentVNode("", true),
                        (interestData.value.length == 0 && _unref(loaded))
                            ? (_openBlock(), _createBlock(Empty, { key: 2 }))
                            : _createCommentVNode("", true),
                        _withDirectives(_createElementVNode("div", _hoisted_26, " 没有更多了 ", 512), [
                            [_vShow, noMore.value && interestData.value.length]
                        ])
                    ]),
                    _: 1
                }, 8, ["loaded", "noMore"])
            ]));
        };
    }
});
